// Constants
import { FUND_CHART_STATE_KEYS, FUND_CHART_APP_STATE_SLICE_KEY, } from 'ChartApp/ts/features/fundamental-chart/constants';
// Services
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import { AppStateService } from 'NewAngular/services/app-state.service';
import { FundChartUrlDeserializer } from 'ChartApp/ts/features/fund-chart-page-shared/fund-chart.serializers';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/app-state.service";
export class FundChartAppStateManager extends AppStateManager {
    constructor(appStateService) {
        super(appStateService);
        this.appStateService = appStateService;
    }
    initAppState() {
        this.appStateService.setStateSlice(FUND_CHART_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(FUND_CHART_STATE_KEYS);
        this.appStateService.setCustomUrlParamDeserializer(FundChartUrlDeserializer);
        this.appStateService.start();
    }
}
FundChartAppStateManager.ɵfac = function FundChartAppStateManager_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartAppStateManager)(i0.ɵɵinject(i1.AppStateService)); };
FundChartAppStateManager.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FundChartAppStateManager, factory: FundChartAppStateManager.ɵfac, providedIn: 'root' });
